module.exports = __webpack_public_path__ + "static/media/001.44a2ae76.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/totoro/001.gif
// module id = 834
// module chunks = 0